import { FC } from "react";
import { LogInScreen } from "./_LoginScreen";

export const AuthScreen: FC = () => {
  return <LogInScreen />;
};

export const stylesheet = {
  global_wrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
    backgroundColor: "#596678",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "35%",
    height: "75%",
    minWidth: 320,
    backgroundColor: "white",
    borderRadius: 25,
    boxSizing: "border-box",
    padding: 25,
  },
  entryContainer: {
    alignSelf: "center",
    width: "100%",
    marginTop: 15,
    marginBottom: 15,
  },
  label: {
    alignSelf: "flex-start",
    marginBottom: 8,
    fontWeight: "500",
  },
  input: {
    fontSize: 15,
  },
  inputIcon: {
    color: "#8c8c8c",
    paddingRight: 5,
  },
  pwd_options: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 10,
  },
  pwd_checkbox: {
    display: "flex",
    alignItems: "center",
  },
  signInBtn: {
    marginTop: 30,
    marginBottom: 15,
    height: 45,
    fontWeight: 600,
  },
  signUpBtn: {
    padding: 0,
  },
} as const;

export const subroute = {
  back_btn: {
    alignSelf: "flex-start",
    position: "absolute",
    top: 20,
    left: 10,
  },
  form: {
    width: "100%",
    marginTop: 20,
  },
  submitBtn: {
    height: 45,
    fontWeight: 600,
  },
} as const;
